<template>
  <b-form autocomplete="off" id="source_submit" @submit="onSubmit">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <b-form>
          <b-form-group label="Название"
                        label-for="title">
            <b-form-input id="title"
                          size="sm"
                          type="text"
                          v-model="userGroup.title">
            </b-form-input>
            <span class=" alert-danger"
                  v-if="submitted && nameValidateMessage">{{ nameValidateMessage }}</span>
          </b-form-group>

          <b-form-group label-for="users">
            <v-select :options="availableUsers"
                      label="name"
                      required v-model="userGroup.users" multiple>
              <span slot="no-options">Совпадений не найдено.</span>
            </v-select>
          </b-form-group>
          <b-button type="submit" class="float-right"
                    v-on:click="onSubmit($event, true)"
                    variant="primary">Сохранить и выйти
          </b-button>
          <span class=" alert-danger" v-if="submitted && message">{{ message }}</span>
          <div class="form-errors"></div>
        </b-form>
      </div>
    </div>
    <div class="form-errors"></div>
  </b-form>
</template>
<script>
import UsersService from '../../../services/usersDataService'

export default {
  name: 'CreateUserGroupModal',
  components: {
    UsersService: UsersService
  },
  data() {
    return {
      userGroup: {
        title: null,
        users: [],
      },
      availableUsers: [],
      submitted: false,
      nameValidateMessage: null,
      message: null,
    }
  },
  methods: {
    onSubmit(evt, close) {
      evt.preventDefault();

      this.submitted = true;
      this.nameValidateMessage = null

      if (!this.validateName()) {
        evt.preventDefault();

        return;
      }

      let usersArray = [];

      if (this.userGroup.users && this.userGroup.users.length != 0) {
        this.userGroup.users.forEach(function (user) {
          usersArray.push(user.id)
        });
      } else {
        usersArray = null
      }

      let data = {
        title: this.userGroup.title,
        users: usersArray,
      }

      UsersService.createUserGroup(data)
          .then(function (response) {
            if (response) {
              this.nameValidateMessage = null

              if (response.error) {
                if (response.error == 'group_exists') {
                  this.message = 'Группа с таким названием уже существует.';
                } else {
                  this.message = 'Произошла ошибка.';
                }

                return;
              }

              window.location.href = '/user-groups';
            }
          }.bind(this))
    },
    validateName() {
      if (!this.userGroup.title) {
        this.nameValidateMessage = 'Поле Название является обязательным.'

        return false;
      }

      return true;
    },
    getAvailableUsers() {
      UsersService.getAvailableUsersForGroups()
          .then(users => {
            this.availableUsers = users
          })
    }
  },
  beforeMount() {
    this.getAvailableUsers()
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/CreateUserGroupModal.vue